import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';

export const MediaIcon = () => <PermMediaOutlinedIcon />;
